import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import routes from '../../../constants/routes.json';
import LogoFullMagenta from '../../../assets/images/logo-magenta.png';
import Services from './Services';
import Items from './Items';
import ZWallet from './ZWallet';
import LogoutLink from '../Topbar/LogoutLink';


class Sidebar extends Component {
    render() {
        return (
            <nav className="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
                <div className="container-fluid">
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#sidenav-collapse-main" aria-controls="sidenav-main" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <Link className="navbar-brand pt-0" to="/">
                        <img src={LogoFullMagenta} className="navbar-brand-img" alt="Logo Zapay" />
                    </Link>
                    <ul className="nav align-items-center d-md-none">
                        <li className="nav-item dropdown">
                            <a className="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div className="media align-items-center">
                                    <span className="avatar avatar-sm rounded-circle">
                                        <img alt="Image placeholder" src="https://cdn3.iconfinder.com/data/icons/web-design-and-development-2-6/512/87-512.png" />
                                    </span>
                                </div>
                            </a>
                            <div className="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
                                {/* <div className=" dropdown-header noti-title">
                                    <h6 className="text-overflow m-0">Welcome!</h6>
                                </div> */}
                                <Link to="/conta" className="dropdown-item">
                                    <i className="fas fa-user" />
                                    <span>Conta</span>
                                </Link>
                                <Link to="/alterar-senha" className="dropdown-item">
                                    <i className="fas fa-lock" />
                                    <span>Alterar Senha</span>
                                </Link>
                                <div className="dropdown-divider" />
                                <LogoutLink />
                            </div>
                        </li>
                    </ul>
                    <div className="collapse navbar-collapse" id="sidenav-collapse-main">
                        <div className="navbar-collapse-header d-md-none">
                            <div className="row">
                                <div className="col-6 collapse-brand">
                                    <Link to="/">
                                        <img src={LogoFullMagenta} />
                                    </Link>
                                </div>
                                <div className="col-6 collapse-close">
                                    <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#sidenav-collapse-main" aria-controls="sidenav-main" aria-expanded="false" aria-label="Toggle sidenav">
                                        <span></span>
                                        <span></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {console.log(this.props.portalUser)}
                        <Items
                            operatorId={this.props.operatorId}
                            portalUser={this.props.portalUser}
                            currentUser={this.props.currentUser}
                        />
                        {/* <hr className="my-3" /> */}
                        {/* <Services /> */}
                        {this.props.zwallet ?
                          <ZWallet />
                        : null}
                    </div>
                </div>
            </nav>
        );
    }
}

const mapStateToProps = state => {
  const { user } = state;
  const { portalUser } = user;
  const { zwalletUser } = user;
  const  operatorId = state.session.operatorId;

  return {
    operatorId: operatorId,
    zwallet: zwalletUser,
    portalUser: portalUser,
    currentUser: user
  }

}

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar/index.js